// source: uaot/options.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_descriptor_pb = require('google-protobuf/google/protobuf/descriptor_pb.js');
goog.object.extend(proto, google_protobuf_descriptor_pb);
goog.exportSymbol('proto.uaot.options.UaotSettings', null, global);
goog.exportSymbol('proto.uaot.options.api', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.uaot.options.UaotSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.uaot.options.UaotSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.uaot.options.UaotSettings.displayName = 'proto.uaot.options.UaotSettings';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.uaot.options.UaotSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.uaot.options.UaotSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.uaot.options.UaotSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.uaot.options.UaotSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    requiredRole: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.uaot.options.UaotSettings}
 */
proto.uaot.options.UaotSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.uaot.options.UaotSettings;
  return proto.uaot.options.UaotSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.uaot.options.UaotSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.uaot.options.UaotSettings}
 */
proto.uaot.options.UaotSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequiredRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.uaot.options.UaotSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.uaot.options.UaotSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.uaot.options.UaotSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.uaot.options.UaotSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequiredRole();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string required_role = 1;
 * @return {string}
 */
proto.uaot.options.UaotSettings.prototype.getRequiredRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.uaot.options.UaotSettings} returns this
 */
proto.uaot.options.UaotSettings.prototype.setRequiredRole = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * A tuple of {field number, class constructor} for the extension
 * field named `api`.
 * @type {!jspb.ExtensionFieldInfo<!proto.uaot.options.UaotSettings>}
 */
proto.uaot.options.api = new jspb.ExtensionFieldInfo(
    1100,
    {api: 0},
    proto.uaot.options.UaotSettings,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.uaot.options.UaotSettings.toObject),
    0);

google_protobuf_descriptor_pb.MethodOptions.extensionsBinary[1100] = new jspb.ExtensionFieldBinaryInfo(
    proto.uaot.options.api,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.uaot.options.UaotSettings.serializeBinaryToWriter,
    proto.uaot.options.UaotSettings.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MethodOptions.extensions[1100] = proto.uaot.options.api;

goog.object.extend(exports, proto.uaot.options);
